const skills = [
    {
        key: 1,
        title: "Business Analysis",
        content: "BA Planning & Monitoring, Negotiation, Stakeholder Collaboration, BA Information Management, Research, Strategy Analysis, Solution Evaluation"
    },
    {
        key: 2,
        title: "Programming Languages",
        content: "C, C++, R, Python"
    },
    {
        key: 3,
        title: "Web Development",
        content: "HTML, CSS, JS, React, NodeJS"
    },
    {
        key: 4,
        title: "Graphical Applications",
        content: "Adobe Illustrator, Adobe InDesign, Adobe Photoshop, Krita, Blender, DaVinci Resolve"
    },
    {
        key: 5,
        title: "Soft Skills",
        content: "Public Speaking, Presentation, Interpersonal communication, TeamWork, Time Management, Adaptability"
    },
    {
        key: 6,
        title: "Data Visualization Tools",
        content: "Tableau, Adobe Ai & Ps, Python"
    },
    {
        key: 7,
        title: "Knowledge Areas",
        content: "Machine Learning, Deep Neural Networks, Generative AI, Data Analytics, Data Science, Web Development, UI/UX, Information Visualization, Cloud Computing, Business Analysis Skills & Techniques"
    }
];

export default skills;